import 'css-chunksrc/client/scenes/wbs/commentsCount/styles.scss';export default {
  "commentsCount": "_commentsCount_14z4e_1",
  "count": "_count_14z4e_8",
  "icon": "_icon_14z4e_14"
};